export const PAYMENT_MODAL_EVENTS = {
  OPEN_MEMBERSHIP_PAYMENT: 'fluxmind-open-membership-payment-modal',
  OPEN_COMPUTE_POWER_PURCHASE: 'fluxmind-open-compute-power-purchase-modal',
} as const;

export function dispatchOpenMembershipPaymentModal() {
  window.dispatchEvent(new CustomEvent(PAYMENT_MODAL_EVENTS.OPEN_MEMBERSHIP_PAYMENT));
}

export function dispatchOpenComputePowerPurchaseModal() {
  window.dispatchEvent(new CustomEvent(PAYMENT_MODAL_EVENTS.OPEN_COMPUTE_POWER_PURCHASE));
}
